import { useNavigate, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useCollection } from '../contexts/CollectionContext';
import WebApp from "@twa-dev/sdk";
import config from '../config';
import sellSound from '../assets/music/sell.mp3';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiService } from '../services/api';
import useUserStore from '../stores/userStore';
import CurrencyIcon from './CurrencyIcon';

const CaseResult = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { assetId } = useParams();
  const { weapon, caseId, caseCost } = location.state;
  const { removeFromCollection } = useCollection();
  const user = useUserStore(state => state.user);
  const setUser = useUserStore.setState;
  const fetchBalance = useUserStore(state => state.fetchBalance);
  const balance = user?.balance ? parseFloat(user.balance) : 0;
  const [shareLoading, setShareLoading] = useState(false);

  useEffect(() => {
    WebApp.BackButton.show();

    const handleBackButton = () => {
      navigate(`/case/${caseId}`, { replace: true });
    };

    WebApp.onEvent('backButtonClicked', handleBackButton);

    return () => {
      WebApp.BackButton.hide();
      WebApp.offEvent('backButtonClicked', handleBackButton);
    };
  }, [navigate, caseId]);

  const handleSell = async () => {
    try {
      await apiService.createSale(weapon.id);

      const audio = new Audio(sellSound);
      audio.play();

      await fetchBalance();

      removeFromCollection(parseInt(assetId));

      navigate(`/case/${caseId}`, { replace: true });
    } catch (error) {
      console.error('Error selling weapon:', error);
      toast.error('Произошла ошибка при продаже предмета', {
        position: "top-center",
        theme: "dark"
      });
    }
  };

  const handleShare = async () => {
    setShareLoading(true);
    try {
      const response = await apiService.savePreparedInlineMessage({ item_id: weapon.id });
      const inlineMessageId = response.id;
      if (window.Telegram?.WebApp?.openTelegramLink && inlineMessageId) {
        window.Telegram.WebApp.shareMessage(inlineMessageId);
      } else {
        await navigator.clipboard.writeText(inlineMessageId);
        toast.success('id скопирован: ' + inlineMessageId);
      }
    } catch (e) {
      toast.error('Ошибка при подготовке сообщения');
    } finally {
      setShareLoading(false);
    }
  };

  return (
    <Container>
      <WeaponCard>
        <WeaponImage
          src={config.getImageUrl(weapon.iconUrl)}
          alt={weapon.name}
        />
        <WeaponInfo>
          <WeaponName>{weapon.name}</WeaponName>
          <WeaponVariant>{weapon.variant || 'Field-Tested'}</WeaponVariant>
        </WeaponInfo>
        <ShareButton onClick={handleShare} disabled={shareLoading}>
          {shareLoading ? '...' : 'Поделиться'}
        </ShareButton>
      </WeaponCard>

      <ButtonsContainer>
        <SpinButton onClick={() => navigate(`/case/${caseId}`, { replace: true })}>
          Spin <CurrencyIcon size={16} /> {caseCost}
        </SpinButton>
        <SellButton onClick={handleSell}>
          Sell for <CurrencyIcon size={16} /> {weapon.tokenPrice}
        </SellButton>
      </ButtonsContainer>
    </Container>
  );
};

const Container = styled.div`
  padding-top: 50px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: ${props => props.theme.background};
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  /* Скрываем скроллбар, но оставляем функциональность */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const WeaponCard = styled.div`
  width: calc(100% - 40px);
  max-width: 400px;
  background: ${props => props.theme.card.background};
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin: 20px auto;
`;

const WeaponImage = styled.img`
  width: 280px;
  height: 210px;
  object-fit: contain;
`;

const WeaponInfo = styled.div`
  text-align: center;
`;

const WeaponName = styled.h2`
  color: ${props => props.theme.text.primary};
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 16px 0;
  text-align: center;
`;

const WeaponVariant = styled.div`
  color: #8E8E93;
  font-size: 16px;
  margin-top: 4px;
`;

const ShareButton = styled.button`
  background: #2C2C2E;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 16px;
  padding: 12px 24px;
  cursor: pointer;
  width: 100%;
  margin-top: 8px;
`;

const ButtonsContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 20px;
  padding-bottom: max(20px, env(safe-area-inset-bottom));
  background: ${props => props.theme.background};
  z-index: 10;
`;

const SpinButton = styled.button`
  background: #2C2C2E;
  border: none;
  border-radius: 12px;
  color: #fff;
  font-size: 17px;
  padding: 16px;
  cursor: pointer;
  width: 100%;
`;

const SellButton = styled.button`
  background: #0A84FF;
  border: none;
  border-radius: 12px;
  color: #fff;
  font-size: 17px;
  padding: 16px;
  cursor: pointer;
  width: 100%;
`;

export default CaseResult;